// extracted by mini-css-extract-plugin
module.exports = {"videos-menu-container":"videos-menu-container-ATzKq"};